// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"f58747d7","312":"405e7044","384":"1924ed3f"}[chunkId] + ".chunk.css";
};